<template>
  <div class="complate-txt pd-vertical-8">
    <div class="tit-h5">
      <span class="primary">{{ formatNumberWithComma(payload) }} {{ t('credit') }}</span>
      {{ t('complete_credit_purchase') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatNumberWithComma } from '@/utils/stringUtils.js';

withDefaults(
  defineProps<{
    payload: number;
  }>(),
  {
    payload: 0,
  }
);
const { t } = useI18n();
</script>

<style scoped lang="scss">
.complate-txt {
  text-align: center;
  margin: 0 auto;
  div {
    word-break: keep-all;
    line-height: 130%;
    max-width: 180px;
  }
}
</style>
